import React, { useEffect, useState } from 'react';
import { Box, Dialog, DialogContent, ListItem, ListItemText, IconButton, CircularProgress, } from '@kareo/design-system';
import CloseIcon from '@material-ui/icons/Close';
import kfetch from '@kareo/kfetch';
import Banner from '../Facesheet/Banner/Banner';
var PatientMessagesNavItem = function (_a) {
    var patientId = _a.patientId;
    // State to manage error state
    var _b = useState(false), hasErrorFetchingPatientInfo = _b[0], setHasErrorFetchingPatientInfo = _b[1];
    // State to manage iframe loaded state
    var _c = useState(false), iframeLoaded = _c[0], setIframeLoaded = _c[1];
    // State to store patient guid
    var _d = useState(''), patientGuid = _d[0], setPatientGuid = _d[1];
    // State to manage dialog visibility
    var _e = useState(false), open = _e[0], setOpen = _e[1];
    // set the iframeLoaded state to true when recieved post message from iframe - used in the template onload of iframe
    var handleIframeLoadedEvent = function (event) {
        var data = event.data, origin = event.origin;
        if (origin === window.location.origin &&
            data === 'messageCenterConversationsLoaded') {
            setIframeLoaded(true);
        }
    };
    useEffect(function () {
        window.addEventListener('message', handleIframeLoadedEvent);
        return function () {
            window.removeEventListener('message', handleIframeLoadedEvent);
        };
    }, []);
    /**
     * Track event in full story
     * @param {string} eventName
     */
    var trackEvent = function (eventName) {
        if (typeof window.FS !== 'undefined') {
            window.FS('trackEvent', {
                name: eventName,
                properties: {
                    patient_id: patientId,
                    patient_guid: patientGuid,
                },
            });
        }
    };
    // open dialog
    var openDialog = function () {
        trackEvent('ptn_MsgModalLoad');
        setOpen(true);
    };
    // close dialog
    var closeDialog = function () {
        trackEvent('ptn_MsgModalClose');
        setIframeLoaded(false);
        setOpen(false);
    };
    // click on nav item
    var clickOnNavItem = function () {
        trackEvent('ptn_MsgLinkClick');
        // fetch patient info
        if (!patientGuid) {
            kfetch("/facesheet-ui/api/Facesheet/patient/" + patientId + "/header")
                .then(function (_a) {
                var guid = _a.guid;
                setPatientGuid(guid);
            })
                .catch(function () {
                setHasErrorFetchingPatientInfo(true);
            });
        }
        openDialog();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ListItem, { onClick: clickOnNavItem, component: "a" },
            React.createElement(ListItemText, { primary: "Messages" })),
        React.createElement(Dialog, { maxWidth: "md", open: open, onClose: closeDialog },
            React.createElement(Box, { position: "absolute", right: "5px" },
                React.createElement(IconButton, { onClick: closeDialog },
                    React.createElement(CloseIcon, null))),
            React.createElement(DialogContent, { style: {
                    minHeight: '400px',
                    width: '50vw',
                    maxWidth: '900px',
                    paddingTop: '2.5em',
                } },
                React.createElement(Banner, { bannerMsg: "This feature is currently in beta. Help us improve by sharing your experience.", severity: "info", href: "https://www.getfeedback.com/r/Jn4Y3zob", extraText: "Leave Feedback" }),
                patientGuid ? (React.createElement(React.Fragment, null,
                    iframeLoaded ? null : (React.createElement(CircularProgress, { thickness: 5, style: {
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            zIndex: 10,
                        } })),
                    React.createElement("iframe", { src: "/messages-ui/#/message-center/messages/guid/" + patientGuid, width: "100%", height: "600px", frameBorder: "0", title: "Patient Messages", style: { display: iframeLoaded ? 'block' : 'none' } }))) : (React.createElement(React.Fragment, null, hasErrorFetchingPatientInfo ? (React.createElement("p", null, "Error fetching patient information")) : (React.createElement(CircularProgress, null))))))));
};
export default PatientMessagesNavItem;
